import { MOCK_CAMPAIGN_PERFORMANCE_SOURCES } from './mockFixtures';
import { CampaignPerformanceSourcesResponse } from './types';

export const buildMockCampaignPerformanceSources = (): CampaignPerformanceSourcesResponse => MOCK_CAMPAIGN_PERFORMANCE_SOURCES;
